import { vModelCheckbox as _vModelCheckbox, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "default-checker" }
const _hoisted_2 = { class: "default-checker__checkbox" }
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "qin-checkbox-main__label" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/static/app/check-icon.svg" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["qin-checkbox-main", { 'ls-checkbox-main--active' : $setup.val }])
      }, [
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", _mergeProps({ class: "checker" }, _ctx.$attrs, {
            type: "checkbox",
            value: $setup.val,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.val) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.setValue($setup.val)))
          }), null, 16, _hoisted_3), [
            [_vModelCheckbox, $setup.val]
          ]),
          _hoisted_4
        ])
      ], 2)
    ])
  ]))
}